module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAAx0lEQVR42u3NwQoBURTG8XkFD8HIAnkNomw8AFlIY2EpSsnCSsqjeIUxUlbDCjPMqMlOUdSc+7nXG8ytazZz6l+nU6eftktlEEcJnMDqYH8wNWW6jcaWP5ysZf81SA4FC9BjBdmJDj83CE81kNsG8zogpwG8tuphui9Bdg7savyifVHc/gHPwewsR7tgXg/skBe3P8DBDOxYBfP7HDb4Xhc39TA+F4ROE3Su8Mpgbgt4O9FhXddNmUqFtCWS/df4II4SOIGV9QXCqUv7jzVOCgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/eg.png
// module id = 813
// module chunks = 0